const mitrexReportStyle = `
@page { 
  margin: 10mm;
  @bottom-left { 
    content: element(footerRun); 
  } 
} 
.running-footer { 
  position: running(footerRun); 
} 
section[data-type='cover'] { 
  page: cover; 
} 
@page cover {
  display: block; 
  page-break-after: always;
  margin: 0mm;
}
section[data-type='last-page'] { 
  page: last-page; 
}
@page last-page {
  @bottom-left { content: none; } 
  margin: 0mm; 
} 
section.content-section { 
  page-break-before: always; 
} 
h1, h2, h3 { 
  page-break-after: avoid; 
} 
.content-subsection img, .content-sub-subsection img { 
  page-break-before: avoid;
}
.break-after {
  page-break-after: always;
}
strong {
  color: #0E4E74;
}
`

export default mitrexReportStyle;